import React, { useRef, useState } from 'react'
import "./ComparsonImage.css"

import ReactBeforeSliderComponent from 'react-before-after-slider-component';
import 'react-before-after-slider-component/dist/build.css';

function ComparsonImage() {

  const FIRST_IMAGE = {
    imageUrl: '/images/creatives/Before.png'
  };
  const SECOND_IMAGE = {
    imageUrl: '/images/creatives/After.png'
  };


  return (
    <div className="ComparsonImage-container d-flex ">
        <div className='container'>

            <ReactBeforeSliderComponent
                firstImage={FIRST_IMAGE}
                secondImage={SECOND_IMAGE}
            />
       
        </div>
    </div>
  );
}

export default ComparsonImage